import { useSelector, useDispatch } from 'react-redux';
import {
  Box,
  Typography,
  ToggleButton,
  ToggleButtonGroup,
} from '@mui/material';
import { RootState } from '../../store/store';
import { setActiveShapeTool } from '../../store/slices/missionPlannerSlice';
import { ShapeKind } from '../../types/missionPlanner';
import { tutorialTarget } from '../../tutorial/tours';

const SHAPE_TOOLS: { kind: ShapeKind; label: string }[] = [
  { kind: 'circle', label: 'Circle' },
  { kind: 'ellipse', label: 'Ellipse' },
  { kind: 'square', label: 'Square' },
  { kind: 'pentagon', label: 'Pentagon' },
];

/**
 * Shape tool palette. Picking a tool arms the map for click-and-drag drawing;
 * picking the active tool again disarms it. Exclusive selection.
 */
export const ShapePalette: React.FC = () => {
  const dispatch = useDispatch();
  const active = useSelector(
    (state: RootState) => state.missionPlanner.activeShapeTool
  );

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
      <Typography variant="subtitle2" component="h3">
        Coverage areas
      </Typography>
      <ToggleButtonGroup
        size="small"
        exclusive
        value={active}
        onChange={(_e, value: ShapeKind | null) =>
          dispatch(setActiveShapeTool(value))
        }
        aria-label="Shape tool"
        sx={{ flexWrap: 'wrap' }}
      >
        {SHAPE_TOOLS.map((t) => (
          <ToggleButton
            key={t.kind}
            value={t.kind}
            aria-label={t.label}
            sx={{ textTransform: 'none', minHeight: 44 }}
            {...tutorialTarget(`planner-shape-${t.kind}`)}
          >
            {t.label}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
      {active && (
        <Typography variant="caption" color="text.secondary" role="status">
          Click and drag on the map to draw a {active}. Press Escape to cancel.
        </Typography>
      )}
    </Box>
  );
};
